<ul
  class="bn-url-list mt-4"
  [ngClass]="{ 'bn-url-list--bold': isBold }">
  @for (item of items; track item.value ?? $index) {
    <li class="py-1">
      <span class="p-2 bn-url-list__container">
        @if (item.icon) {
          <span class="bn-url-list__icon--left">
            <fa-icon [icon]="item.icon" />
          </span>
        }
        <a
          class="bn-url-list__url"
          [href]="item.href"
          [target]="item.target"
          >{{ item.value }}
        </a>
        @if (item.iconRight) {
          <span class="bn-url-list__icon--right">
            <fa-icon [icon]="item.iconRight" />
          </span>
        }
      </span>
    </li>
  }
</ul>
